import React, { useEffect, useRef, useState } from 'react'
import Breadcrumb from '../../../core/common/Breadcrumb/breadcrumb';
import { all_routes } from '../../router/all_routes';
import { useParams } from 'react-router-dom';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BannerCounter from '../../../core/common/banner-counter/counter';
import Lightbox from "yet-another-react-lightbox";
import Reviews from '../../../core/common/reviews/reviews';
import { getPacoteById } from '../../../core/API/pacotes';
import { Link } from 'react-router-dom';
import { PacoteDTO } from '../../../core/common/PacoteContext/PacoteContext';
import ShowMoreText from '../../../core/common/Text/ShowMoreText';
import axios from "axios";
import MapaPacote from '../../../core/common/Map/MapaPacote';
import DriverDetails from "./DriverDetails";
import FlightBookingButton from './FlightBookingButton';
import { t } from "../../../lang/index"

type FAQItem = { question: string; answer: string };
type FAQ = { subtitle: string; questions: FAQItem[] };

type VeiculoDTO = {
    veiculoId: number;
    modelo: string;
    placa: string;
    capacidade: number;
    fotoUrl?: string;
    seguroUrl?: string;
    licencaRnaatUrl?: string;
};

type MotoristaDTO = {
    id: number;
    nome: string;
    email: string;
    telefone?: string;
    documento?: string;
    numeroCartaConducao?: string;
    dataExpedicao?: string;
    dataValidade?: string;
    categoria?: string;
    idiomas?: string[];
    registoCriminal?: string;
    fotoId?: number;
    veiculo?: VeiculoDTO;
    descricao?: string;
};

// 🔹 Tipo para avaliações
type AvaliacaoDTO = {
    id: number;
    nota: number;
    comentario: string;
    usuarioNome: string;
    usuarioFotoUrl?: string;
    fotos?: number[];
    fotosPorPonto?: { fotoId: number; ponto: string; url: string }[];
    pacoteId: number;
};

// 🔹 Motorista com avaliações embutidas
type MotoristaComAvaliacoes = MotoristaDTO & {
    avaliacoes: AvaliacaoDTO[];
};


// Mapeamento do público-alvo para inglês
const publicoAlvoMap: Record<string, string> = {
    ADULTOS: "Adults",
    CRIANCAS_ACOMPANHADAS: "Children with Guardians",
    FAMILIA: "Family",
    TODOS: "All"
};

const FlightDetails = () => {
    const BASE_URL = process.env.REACT_APP_API_URL;
    const { id } = useParams<{ id: string }>(); // pega ID da URL
    const routes = all_routes;
    const [gallery, setGallery] = React.useState(false);
    const [packageData, setPackageData] = useState<PacoteDTO | null>(null);

    const faq = t("home.updateSection.faq") as FAQ;

    //Breadcrumb Data
    const breadcrumbs = [
        {
            label: 'Package Details',
            active: false,
            link: routes.home1
        },
        {
            label: 'Package',
            active: false,
        },
        {
            label: 'Package Details',
            active: true,
        },
    ];

    const sliderForRef = useRef<any>(null);
    const sliderNavRef = useRef<any>(null);
    const [navSync, setNavSync] = useState<any>({ sliderFor: null, sliderNav: null });

    const CustomNextArrow = ({ onClick }: any) => (
        <div className="owl-nav">
            <button type="button" role="presentation" className="owl-next" onClick={onClick}>
                <i className="fa-solid fa-chevron-right" />
            </button>
        </div>
    );

    const CustomPrevArrow = ({ onClick }: any) => (
        <div className="owl-nav">
            <button type="button" role="presentation" className="owl-prev" onClick={onClick}>
                <i className="fa-solid fa-chevron-left" />
            </button>
        </div>
    );

    useEffect(() => {
        setNavSync({
            sliderFor: sliderNavRef.current,
            sliderNav: sliderForRef.current,
        });
    }, []);

    // 🔹 Agora usando o tipo MotoristaComAvaliacoes
    const [motoristas, setMotoristas] = useState<MotoristaComAvaliacoes[]>([]);

    useEffect(() => {
        const fetchPacote = async () => {
            if (!id) return;

            try {
                const data = await getPacoteById(id);
                setPackageData(data);

                // 🔹 Buscar motoristas do pacote
                if (data.motoristaIds && data.motoristaIds.length > 0) {
                    const responses = await Promise.all(
                        data.motoristaIds.map(async (mid: number) => {
                            // 1. Dados básicos do motorista
                            const motoristaRes = await axios.get<MotoristaDTO>(
                                `${BASE_URL}/motorista/${mid}`
                            );

                            // 2. Avaliações do motorista
                            const avaliacoesRes = await axios.get<AvaliacaoDTO[]>(
                                `${BASE_URL}/avaliacoes/motorista/${mid}`
                            );

                            // 3. Combinar os dados
                            return {
                                ...motoristaRes.data,
                                avaliacoes: avaliacoesRes.data,
                            } as MotoristaComAvaliacoes;
                        })
                    );

                    setMotoristas(responses);
                }
            } catch (error) {
                console.error("Erro ao buscar pacote/motoristas:", error);
            }
        };

        fetchPacote();
    }, [id, BASE_URL]);

    const [resumo, setResumo] = useState<{ media: number; total: number } | null>(null);

    useEffect(() => {
        if (!id) return;
        axios.get(`${BASE_URL}/avaliacoes/pacote/${id}/resumo`).then((res) => setResumo(res.data));
    }, [id, BASE_URL]);


    const largeImage = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: false,
        infinite: (packageData?.fotoUrls?.length || 0) + (packageData?.videoUrls?.length || 0) > 1,
        speed: 2000,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        asNavFor: navSync.sliderFor,
    };

    const smallImage = {
        slidesToShow: 5,
        slidesToScroll: 0,
        focusOnSelect: true,
        dots: false,
        arrows: false,
        infinite: false,
        speed: 1000,
        margin: 10,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        asNavFor: navSync.sliderNav,
        responsive: [
            {
                breakpoint: 992,
                settings: { slidesToShow: 5 },
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 3 },
            },
            {
                breakpoint: 580,
                settings: { slidesToShow: 2 },
            },
            {
                breakpoint: 0,
                settings: { vertical: false, slidesToShow: 1 },
            },
        ],
    };

    return (
        <div>
            <Breadcrumb title="Package" breadcrumbs={breadcrumbs} backgroundClass="breadcrumb-bg-05" />

            <>
                {/* Page Wrapper */}
                <div className="content">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-8">
                                {/* Slider */}
                                <div>
                                    <div className="service-wrap slider-wrap-five mb-4">
                                        <div className="d-flex align-items-center justify-content-between flex-wrap mb-2">
                                            <div className="mb-2">
                                                <h4 className="mb-1 d-flex align-items-center flex-wrap">
                                                    {packageData?.titulo}

                                                    {/* Badge Verified */}
                                                    <span className="badge badge-xs bg-success rounded-pill ms-2">
                                                        <i className="isax isax-ticket-star5 me-1" />
                                                        Verified
                                                    </span>

                                                    {/* Avaliações */}
                                                    {resumo ? (
                                                        resumo.total > 0 ? (
                                                            <div className="d-flex align-items-center ms-2">
                                                                {/* Nota média */}
                                                                <span className="badge badge-warning badge-xs text-gray-9 fs-10 fw-medium me-2 p-1">
                                                                    <i className="isax isax-star" />
                                                                    {resumo.media.toFixed(1)}
                                                                </span>

                                                                {/* Total de reviews */}
                                                                <p className="fs-14 mb-0">
                                                                    <Link to="#reviews">({resumo.total} Reviews)</Link>
                                                                </p>
                                                            </div>
                                                        ) : (
                                                            <p className="fs-14 mb-0 text-muted ms-2">Ainda não há avaliações</p>
                                                        )
                                                    ) : null}
                                                </h4>
                                            </div>
                                        </div>

                                        {/* Carrossel principal */}
                                        <div className="service-wrap mb-4">
                                            <div className="slider-wrap">
                                                <div
                                                    className="owl-carousel service-carousel nav-center mb-4"
                                                    id="large-img"
                                                >
                                                    <Slider {...largeImage} ref={sliderForRef}>
                                                        {/* Fotos */}
                                                        {packageData?.fotoUrls?.map((url, idx) => (
                                                            <div key={`foto-${idx}`} className="service-img">
                                                                <img
                                                                    src={`${BASE_URL}${url}`}
                                                                    className="img-fluid"
                                                                    alt={`Foto ${idx + 1}`}
                                                                />
                                                            </div>
                                                        ))}

                                                        {/* Vídeos */}
                                                        {packageData?.videoUrls?.map((url, idx) => (
                                                            <div key={`video-${idx}`} className="service-img">
                                                                <video
                                                                    src={`${BASE_URL}${url}`}
                                                                    controls
                                                                    className="img-fluid rounded"
                                                                    style={{ maxHeight: "500px", width: "100%" }}
                                                                />
                                                            </div>
                                                        ))}
                                                    </Slider>
                                                </div>

                                                {/* Lightbox */}
                                                <Lightbox
                                                    open={gallery}
                                                    close={() => setGallery(false)}
                                                    slides={[
                                                        ...(packageData?.fotoUrls?.map((url) => ({ src: `${BASE_URL}${url}` })) || []),
                                                        ...(packageData?.videoUrls?.map((url) => ({ src: `${BASE_URL}${url}` })) || []),
                                                    ]}
                                                />
                                            </div>

                                            {/* Thumbnails */}
                                            <div className="owl-carousel slider-nav-thumbnails nav-center" id="small-img">
                                                <Slider {...smallImage} ref={sliderNavRef}>
                                                    {/* Fotos */}
                                                    {packageData?.fotoUrls?.map((url, idx) => (
                                                        <div key={`thumb-foto-${idx}`}>
                                                            <img
                                                                src={`${BASE_URL}${url}`}
                                                                className="img-fluid"
                                                                alt={`Thumb Foto ${idx + 1}`}
                                                            />
                                                        </div>
                                                    ))}

                                                    {/* Vídeos */}
                                                    {packageData?.videoUrls?.map((url, idx) => (
                                                        <div
                                                            key={`thumb-video-${idx}`}
                                                            className="position-relative d-flex align-items-center justify-content-center"
                                                            style={{ height: 80, cursor: "pointer", overflow: "hidden", borderRadius: 8 }}
                                                        >
                                                            {/* Miniatura do vídeo */}
                                                            <video
                                                                src={`${BASE_URL}${url}#t=1`} // pega frame inicial
                                                                className="img-fluid"
                                                                style={{ objectFit: "cover", height: "100%", width: "100%" }}
                                                            />
                                                            {/* Ícone de play sobreposto */}
                                                            <span
                                                                className="position-absolute"
                                                                style={{
                                                                    fontSize: 24,
                                                                    color: "white",
                                                                    pointerEvents: "none",
                                                                }}
                                                            >
                                                                ▶️
                                                            </span>
                                                        </div>
                                                    ))}
                                                </Slider>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* /Slider */}
                                <div className="accordion custom-accordion accordion-shadow-none">
                                    <div className="accordion-item border-0 mb-4">
                                        <div className="accordion-header">
                                            <button
                                                className="accordion-button"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#accordion_collapse_two"
                                                aria-expanded="true"
                                            >
                                                Description
                                            </button>
                                        </div>
                                        <div
                                            id="accordion_collapse_two"
                                            className="accordion-collapse collapse show"
                                        >
                                            <div className="accordion-body pt-0">
                                                {packageData?.descricao && (
                                                    <ShowMoreText text={packageData.descricao} limit={200} />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item mb-0 border-0 pb-1">
                                        <div className="accordion-header">
                                            <button
                                                className="accordion-button"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#accordion_collapse_three"
                                                aria-expanded="true"
                                            >
                                                Highlights
                                            </button>
                                        </div>
                                        <div
                                            id="accordion_collapse_three"
                                            className="accordion-collapse collapse show"
                                        >
                                            <div className="accordion-body pt-0">
                                                <div className="row">
                                                    {/* Column Differentials */}
                                                    <div className="col-lg-6 col-md-6">
                                                        <div className="mb-3">
                                                            <h6 className="mb-2">Differentials</h6>
                                                            {packageData?.diferenciais?.length ? (
                                                                packageData.diferenciais.map((dif, idx) => (
                                                                    <div
                                                                        key={dif.id ?? idx}
                                                                        className="d-flex align-items-center mb-2"
                                                                    >
                                                                        <i className="isax isax-verify text-primary me-2 fs-16" />
                                                                        <p className="mb-0">
                                                                            {dif.descricaoCustomizada ??
                                                                                `${dif.tipo}${dif.quantidade ? ` (${dif.quantidade})` : ""}`}
                                                                        </p>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <p className="text-muted">No differentials available</p>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Column Points of Interest */}
                                                    <div className="col-lg-6 col-md-6">
                                                        <div className="mb-3">
                                                            <h6 className="mb-2">Points of Interest</h6>
                                                            {packageData?.pontosDeInteresse?.length ? (
                                                                packageData.pontosDeInteresse.map((ponto, idx) => (
                                                                    <div key={idx} className="d-flex align-items-center mb-2">
                                                                        <i className="isax isax-verify text-primary me-2 fs-16" />
                                                                        <p className="mb-0">{ponto}</p>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <p className="text-muted">No points of interest available</p>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item mb-4 border-0">
                                        <div className="accordion-header">
                                            <button
                                                className="accordion-button"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#accordion_collapse_eight"
                                                aria-expanded="true"
                                            >
                                                {t("home.updateSection.faq.title", { highlight: t("home.updateSection.faq.highlight") })}
                                            </button>
                                        </div>
                                        <div
                                            id="accordion_collapse_eight"
                                            className="accordion-collapse collapse show"
                                        >
                                            <div className="accordion-body pt-0">
                                                <p className="mb-3">{faq.subtitle}</p>
                                                <div className="accordion faq-accordion" id="accordionFaq">
                                                    {faq.questions.map((q: any, idx: number) => (
                                                        <div key={idx} className="accordion-item mb-2">
                                                            <div className="accordion-header">
                                                                <button
                                                                    className={`accordion-button fw-medium ${idx !== 0 ? 'collapsed' : ''}`}
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target={`#faq-collapse-${idx}`}
                                                                    aria-controls={`faq-collapse-${idx}`}
                                                                >
                                                                    {q.question}
                                                                </button>
                                                            </div>
                                                            <div
                                                                id={`faq-collapse-${idx}`}
                                                                className={`accordion-collapse collapse ${idx === 0 ? 'show' : ''}`}
                                                                data-bs-parent="#accordionFaq"
                                                            >
                                                                <div className="accordion-body">
                                                                    <p className="mb-0">{q.answer}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="accordion-item mb-xl-0 mb-4 shadow-sm p-3 border-0"
                                        id="reviews"
                                    >
                                        <div className="accordion-header">
                                            <button
                                                className="accordion-button"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#accordion_collapse_nine"
                                                aria-expanded="true"
                                            >
                                                Reviews
                                            </button>
                                        </div>
                                        <div
                                            id="accordion_collapse_nine"
                                            className="accordion-collapse collapse show"
                                        >
                                            <div className="accordion-body border-top mt-3 pt-3">
                                                {id ? <Reviews pacoteId={Number(id)} /> : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 ">
                                <div className="">
                                    <div className="card shadow-none">
                                        <div className="card-body">

                                            {/* Preço */}
                                            <div className="d-flex align-items-center justify-content-between bg-light-200 rounded p-3 mb-3">
                                                <p className="fs-13 fw-medium mb-0">Price</p>
                                                <h5 className="text-primary">
                                                    ${packageData?.precoBase}{" "}
                                                    <span className="fs-14 text-default fw-normal">/ Person</span>
                                                </h5>
                                            </div>

                                            {/* Duração */}
                                            {packageData?.duracaoEmMinutos && (
                                                <div className="d-flex align-items-center justify-content-between bg-light-200 rounded p-3 mb-3">
                                                    <p className="fs-13 fw-medium mb-0">Duration (minutes)</p>
                                                    <h6 className="text-dark mb-0">{packageData.duracaoEmMinutos}</h6>
                                                </div>
                                            )}

                                            {/* Linha com Idade mínima e Público-alvo (centralizada) */}
                                            {(packageData?.idadeMinima !== undefined || packageData?.publicoAlvo) && (
                                                <div className="d-flex justify-content-center gap-3 mb-3">

                                                    {/* Idade mínima */}
                                                    {packageData?.idadeMinima !== undefined && (
                                                        <div className="flex-1 bg-light-200 rounded p-3 text-center d-flex flex-column align-items-center justify-content-center">
                                                            <p className="fs-13 fw-medium mb-0">Minimum Age</p>
                                                            <h6 className="mb-0">{packageData.idadeMinima}</h6>
                                                        </div>
                                                    )}

                                                    {/* Público-alvo */}
                                                    {packageData?.publicoAlvo && (
                                                        <div className="flex-1 bg-light-200 rounded p-3 text-center d-flex flex-column align-items-center justify-content-center">
                                                            <p className="fs-13 fw-medium mb-0">Target Audience</p>
                                                            <h6 className="mb-0">
                                                                {publicoAlvoMap[packageData.publicoAlvo] || packageData.publicoAlvo}
                                                            </h6>
                                                        </div>
                                                    )}

                                                </div>
                                            )}

                                            {/* Botão Book Now */}
                                            <div className="banner-form">
                                                {packageData && <FlightBookingButton packageId={packageData.id!} />}
                                            </div>

                                        </div>
                                    </div>

                                    {/* Map */}
                                    <div className="card shadow-none" id="location">
                                        {/* Container do mapa com altura definida */}
                                        <div style={{ width: "100%", height: "400px", position: "relative" }}>
                                            {packageData ? (
                                                <MapaPacote
                                                    pontosImportantes={packageData.pontosImportantes || []}
                                                    pontosInteresse={packageData.pontosDeInteresse || []}
                                                />
                                            ) : (
                                                <p>Loading map...</p>
                                            )}
                                        </div>

                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                                                <p className="d-flex align-items-center mb-0">
                                                    <i className="isax isax-location5 me-2" />
                                                    {packageData?.titulo || "Package location"}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* /Map */}

                                    <div className="card shadow-none mb-0">
                                        {/* 🔹 Usando o novo DriverDetails */}
                                        <DriverDetails motoristas={motoristas} />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {/* /Page Wrapper */}
            </>


        </div>
    )
}

export default FlightDetails
